import { mountPdfExportButton, unmountPdfExportButton } from './src/pdf-export';

const PLUGIN_NAME = 'growi-plugin-pdf-export';
const LOG = `[${PLUGIN_NAME}]`;

declare global {
  interface Window {
    pluginActivators?: Record<
      string,
      { activate: () => void; deactivate: () => void }
    >;
    growiFacade?: unknown;
  }
}

let activated = false;

const activate = (): void => {
  if (activated) return;
  activated = true;
  console.info(`${LOG} activate() called`);
  try {
    mountPdfExportButton();
  } catch (err) {
    console.error(`${LOG} activate failed:`, err);
  }
};

const deactivate = (): void => {
  activated = false;
  try {
    unmountPdfExportButton();
  } catch (err) {
    console.error(`${LOG} deactivate failed:`, err);
  }
};

if (window.pluginActivators == null) {
  window.pluginActivators = {};
}
window.pluginActivators[PLUGIN_NAME] = { activate, deactivate };
console.info(`${LOG} registered to window.pluginActivators`);

// 一部の GROWI バージョンでは activate を自動呼出ししない場合があるため、
// スクリプトロード後しばらく待ってもまだ activate されていなければ自前で発火する。
window.setTimeout(() => {
  if (!activated) {
    console.warn(`${LOG} activate() was not invoked by host; self-activating.`);
    activate();
  }
}, 2000);
